import "./educationSolutionVisual.css";
import { getHealthProductPreviewSrc } from "../health/healthProductPreviewAssets";

interface EducationBlendVisualProps {
    assetKey: string | undefined;
    alt: string;
    loading?: "eager" | "lazy";
}

export function EducationBlendVisual({
    assetKey,
    alt,
    loading = "lazy",
}: EducationBlendVisualProps) {
    const src = getHealthProductPreviewSrc(assetKey);
    if (!src) return null;

    return (
        <div className="education-solution-visual">
            <img
                src={src}
                alt={alt}
                className="education-solution-visual__img"
                loading={loading}
                decoding="async"
            />
            <div className="education-solution-visual__fade" aria-hidden="true" />
        </div>
    );
}
